import { Link, useNavigate } from "react-router-dom";
import axios from 'axios'
import { useState } from "react";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const Login = () => {
    const navigate = useNavigate()
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [loading, setLoading] = useState(false)
    const { t } = useTranslation()

    const submitForm = async () => {
        localStorage.removeItem("token")
        localStorage.removeItem("user")
        localStorage.removeItem("selectedStudent")
        setLoading(true)
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/login`, {
            email: email,
            password: password,
            role:"parent"
        }).then( res => {
            setLoading(false)
            console.log("res", res)
            localStorage.setItem("user", JSON.stringify(res.data.user))
            localStorage.setItem("token", res.data.token)
            localStorage.setItem("role", "parent")
            navigate("/profile")
        }).catch( err => {
            setLoading(false)
            console.log("err", err)
            if (err && err.response && err.response.data && err.response.data.error) {
                toast.error(err.response.data.error)
            } else {
                toast.error("Invalid credentials")
            }
        })
    }


    return (
        <div style={{paddingTop:"1rem", paddingRight: "1rem", paddingLeft:"1rem", height:"100vh"}}>
            <div className="auth-page-header mb-10">
                <div className="container">
                    <img src={process.env.PUBLIC_URL + "/assets/img/koku.png"} className="img-fluid w-20" alt="" />
                    <div className="flex">
                        <h3 className="text-2xl self-center">{t('login.parent_login')}</h3>
                    </div>
                </div>
            </div>
            <div className="auth-page-body">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="auth-form rounded-3xl">
                                <form>
                                    <div className="auth-form__single-field space-mb--30">
                                        <label htmlFor="emailAddress">{t('login.email')}</label>
                                        <input value={email} onChange={(e)=>{setEmail(e.target.value)}} type="text" name="emailAddress" id="emailAddress" placeholder={t('login.enter_email')} />
                                    </div>
                                    <div className="auth-form__single-field space-mb--30">
                                        <label htmlFor="password">{t('login.password')}</label>
                                        <input value={password} onChange={(e)=>{setPassword(e.target.value)}}  type="password" name="password" id="password" placeholder={t('login.enter_password')}/>
                                    </div>
                                    <div className="auth-form__single-field space-mb--10">
                                        <p className="auth-form__info-text">
                                        {t('login.dont_have_account')}{" "}
                                        <Link to={"/register"}>{t('login.sign_up_now')}</Link>
                                        </p>
                                    </div>
                                    <div className="auth-form__single-field space-mb--30">
                                        <p className="auth-form__info-text">
                                        {t('login.forget_password')}{" "}
                                        <Link to={"/reset-password"}>{t('login.reset_password')}</Link>
                                        </p>
                                    </div>
                                    <button type="button" onClick={(e)=>(submitForm())} className="text-white text-[16px] leading-none w-full py-[15px] bg-theme border-none rounded-3xl flex items-center justify-center">
                                    {loading ? <FaSpinner className="animate-spin"/> : t('login.login')}
                                    </button>

                                    <div className="row w-3/6 my-4 px-2 float-right">
                                        <select className="px-2 py-1 border rounded-full text-md bg-white focus:outline-none focus:ring-2 focus:ring-theme appearance-none" onChange={(e) => { i18next.changeLanguage(e.target.value) }}>
                                            <option value="-1" selected disabled>-- Language --</option>
                                            <option value="en">English</option>
                                            <option value="zh">Mandarin</option>
                                            <option value="ms">Bahasa</option>
                                        </select>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            
        </div>
    )
}

export default Login;
